export const CLOSED_WIDGET = "closedWidget";
export const SHOWN_WIDGET = "shownWidget";
export const IS_MOBILE = "isMobile";
export const IS_ONLINE = "onlineStatus";
export const SOUND_ENABLED = "toggleSound";
export const ENDED_CHAT = "endedChat";

// Internal actions
export const OFFLINE_FIELDS_UPDATED = "OFFLINE_FIELDS_UPDATED";
export const ONLINE_SUBMITTED = "ONLINE_SUBMITTED";